import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from 'context/user'
import { isApprovalAdmin, isReportApprovalFlowEnabled } from 'utility/role-model'

/**
 * Report-approval screens: shown when the global SHOW_REPORT_APPROVAL_FLOW flag is on, and always for companies on the
 * department role model (in-app approvals by the quality head / department heads). Everyone else is redirected as
 * before.
 */
export const ApprovalFlowGate = ({
    children,
    redirectTo = '/app/task',
    adminOnly = false,
}) => {
    const { user } = useAuth()
    if (
        !isReportApprovalFlowEnabled(user) ||
        (adminOnly && !isApprovalAdmin(user))
    ) {
        return <Navigate to={redirectTo} replace />
    }
    return children
}
